import { httpGet, httpPost, httpPost_New } from './api.service';
import { Result } from '../types/Result';
import { SingleResult } from '../types/SingleResult';

const getAdmissionRequests = async (params): Promise<Result<any>> => {
  return await httpGet(`api/user-registration`, params);
};

const admitUsers = async (ids: string[]): Promise<string> => {
  return await httpPost_New(`api/user-registration/admit`, { ids: ids });
};

const declineUsers = async (ids: string[]): Promise<string> => {
  return await httpPost_New(`api/user-registration/decline`, { ids: ids });
};

const completeRegistration = async (id: string): Promise<string> => {
  return await httpPost_New<string>(`api/user-registration/complete/${id}`);
};

export { getAdmissionRequests, admitUsers, declineUsers, completeRegistration };
